<template>
  <page :basic="true" class="client-items">
    <template v-if="preview">
      <span slot="header">Items</span>
      <span slot="breadcrumbs">
        <b-alert show variant="warning" class="text-center">
          You are in preview mode.
          <br>
          <router-link :to="{name: 'admin-items', query: {dontFetch: true}}">
            <i class="fas fa-hand-point-left"></i>
            &nbsp;back to editing
          </router-link>
        </b-alert>
      </span>
    </template>
    <template v-else>
      <span slot="header">Items</span>
      <span slot="breadcrumbs">
        <b-breadcrumb :items="breadcrumbs"/>
        <span v-if="role === 'owner' || role === 'master' || role === 'admin'">
          <router-link :to="{name: 'admin-items'}">
            <i class="fas fa-exchange-alt"></i> Switch to Admin View
          </router-link>
        </span>
      </span>
    </template>

    <div class="topic-header">
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
    </div>

    <template v-if="items.length">
      <template v-for="item in items">
        <component
          :key="item.id"
          :preview="preview"
          :item="item"
          :is="'item-' + item.type"/>
      </template>
    </template>

    <no-data v-if="!fetching && !items.length" class="topic-header" message="This topic appears to be empty..."/>

  </page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import page from '../../../templates/page'
import noData from '../../../common/table/no-data'
import itemRow from './row'
import itemMediaGroup from './media-group'
import itemParagraph from './paragraph'
import itemImage from './image'
import itemVideo from './video'
import itemPdf from './pdf'
import itemAudio from './audio'

export default {
  components: {
    page,
    noData,
    itemRow,
    itemParagraph,
    itemMediaGroup,
    itemImage,
    itemVideo,
    itemAudio,
    itemPdf
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: { name: 'client-modules' }
      },
      {
        text: 'Components',
        to: { name: 'client-components' }
      },
      {
        text: 'Topics',
        to: { name: 'client-topics' }
      },
      {
        text: 'Items',
        active: true
      }]
    }
  },
  computed: {
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    ...mapState('items', {
      fetching: 'fetching'
    }),
    items () {
      return this.$store.getters['items/forClient'](this.preview)
    },
    title () {
      return this.$store.state.topics.current.name
    },
    description () {
      return this.$store.state.topics.current.description
    },
    preview () {
      return this.$route.query.preview
    }
  }
}
</script>

<style lang="scss">
.client-items {
  .card-body {
    padding: 0 !important;
  }
}

.topic-header {
  padding: 1.25rem;
}

.alert {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/index.vue